import React from "react";

const DeveloperInfo = () => {
  return <div>{new Date().getFullYear()} &copy; Pranab Acharya</div>;
};

export default DeveloperInfo;
